import React from 'react';
import { useDialogStore } from './useDialogStore';
import { getLegacyDialogMapper } from './utils';
import { TLegacyDialogKey } from './DialogStore.types';

/**
 * Component to render dialogs from the dialog store.
 */
export const DialogStore = () => {
  const { dialogs } = useDialogStore();

  if (!dialogs.length) {
    return null;
  }

  return (
    <>
      {dialogs?.map(dialog => {
        if (!dialog?.component) {
          const Dialog = getLegacyDialogMapper(dialog.key as TLegacyDialogKey);

          if (Dialog !== null) {
            return <Dialog key={dialog.key} />;
          }
        }

        return dialog.component;
      })}
    </>
  );
};
